module.exports = __webpack_public_path__ + "133268301edf16f993801ea412db36d9.svg";